export const APPLY_ATT_LABEL = 'Apply AT&T Recommendations';

export enum ActivationAction {
    ACTIVATE = 'Activate ',
    DEACTIVATE = 'Deactivate       '
}

export enum BulkRecommendationType {
    COUNTRY = 'COUNTRY',
    CATEGORY = 'CATEGORY',
    ATP_PROFILES = 'ATP_PROFILES',
}

export enum BulkUpdateType {
    COUNTRY = 'COUNTRY',
    CATEGORY = 'CATEGORY',
    APPS = 'APPS',
    SERVICES = 'SERVICES',
    IP_CONTROL_ALLOW_LIST = 'IP_CONTROL_ALLOW_LIST',
    IP_CONTROL_BLOCK_LIST = 'IP_CONTROL_BLOCK_LIST',
    IP_CONTROL_ALL = 'IP_CONTROL_ALL',
    DOMAINS_ALLOW = 'DOMAINS_ALLOW',
    DOMAINS_BLOCK = 'DOMAINS_BLOCK'
}

export enum BulkUpdateDirection {
    OUTBOUND = 'outbound',
    INTBOUND = 'inbound',
    BOTH = 'both'
}

export enum BulkUpdateAction {
    RECOMMENDATION = 'recommendation',
    ALLOW_ALL = 'ALLOW_ALL',
    BLOCK_ALL = 'BLOCK_ALL',
    CLEAR_ALL = 'CLEAR_ALL'
}